import { DeviceInfo } from "@travello/grpc-api/js/common_pb";

import uuid from "uuid/v4";

import { REPO_VERSION } from "@/env";

import { DEVICE_ID } from "@/bootstrap";

export const APPLICATION_ID = "TRAVELLO";

export const getDeviceInfo = (deviceId: string) => {
  const deviceInfo: DeviceInfo = new DeviceInfo();
  deviceInfo.setType(DeviceInfo.DeviceType.WEB);
  deviceInfo.setDeviceId(deviceId);
  if (REPO_VERSION) {
    deviceInfo.setAppVersion(REPO_VERSION);
  }
  deviceInfo.setTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  deviceInfo.setDeviceName("Web Browser");
  return deviceInfo;
};

export const DEVICE_INFO = getDeviceInfo(DEVICE_ID ?? uuid());
